import { render, staticRenderFns } from "./FondoRotativo.vue?vue&type=template&id=65caf3f0"
import script from "./FondoRotativo.js?vue&type=script&lang=js&external"
export * from "./FondoRotativo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports